import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/custom.css";
import "./styles/tailwind.pcss";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import SidebarComponent from "./components/Sidebar";
import Orders from "./pages/Orders";
import DynamicOrderForm from "./components/DynamicOrderForm/DynamicOrderForm";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import CreateClient from "./pages/CreateClient";
import CreateSupplier from "./pages/CreateSupplier";
import MonthlySummary from "./pages/MonthlySummary";
import NotAuthorized from "./pages/NotAuthorized";
import { AuthProvider } from "./components/shared/AuthContext";
import { ProtectedRoute } from "./components/shared/ProtectedRoute";

// Shell for protected area (includes Sidebar)
const AppShell = () => (
  <SidebarComponent>
    <Outlet />
  </SidebarComponent>
);

export default function Root() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          <Route path="/not-authorized" element={<NotAuthorized />} />

          <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/users" element={<Users />} />
            <Route path="/orders/view/:id" element={<DynamicOrderForm />} />
            <Route path="/create-client" element={<CreateClient />} />
            <Route path="/create-supplier" element={<CreateSupplier />} />
            <Route path="/monthly-summary" element={<MonthlySummary />} />
          </Route>

          {/* Print route — protected but no sidebar */}
          <Route
            path="/orders/print/:id"
            element={
              <ProtectedRoute>
                <DynamicOrderForm />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
